"use client";

import posthog from "posthog-js";

import { sanitizeAnalyticsProperties, type AnalyticsProperties } from "./events";

export function captureAnalyticsException(error: unknown, props: AnalyticsProperties = {}) {
  posthog.captureException(error, sanitizeAnalyticsProperties(props));
}
